import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

export const initEminogluTeam = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    ".eminoglu-team__swiper",
  );

  if (sliders.length === 0) return;

  sliders.forEach((sliderElement) => {
    const wrapper = sliderElement.closest(".eminoglu-team__slider-wrapper");
    const nextBtn = wrapper?.querySelector(
      ".ea-slider-nav--next",
    ) as HTMLElement;
    const prevBtn = wrapper?.querySelector(
      ".ea-slider-nav--prev",
    ) as HTMLElement;

    const slideCount = sliderElement.querySelectorAll(".swiper-slide").length;
    // Update loop logic to check against the new desktop slidesPerView (4)
    const shouldLoop = slideCount > 4;

    const autoplayConfig = shouldLoop
      ? { delay: 5000, disableOnInteraction: true }
      : false;

    new Swiper(sliderElement, {
      modules: [Navigation, Autoplay],
      loop: shouldLoop,
      spaceBetween: 24, // Adjusted spacing for the denser grid
      grabCursor: true,
      watchOverflow: true,

      autoplay: autoplayConfig,

      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        320: { slidesPerView: 1.5, spaceBetween: 15 },
        768: { slidesPerView: 3, spaceBetween: 20 },
        // Increased from 3 to 4 per row to make cards smaller
        1024: { slidesPerView: 4, spaceBetween: 24 },
      },
    });
  });

  console.log("[EminogluTeam] Slider initialized.");
};
